import React from 'react';
import "./css/Home.css";
import BannerSection from './BannerSection';
import TopTrendingSection from './TopTrendingSection';
import AddSection from './AddSection';
import PopularIndianSection from './PopularIndianSection';
import PopularTourSection from './PopularTourSection';
import InternationalPackages from './InternationalPackages';
import PopularInternationalSection from './PopularInternationalSection';
import HolidayThemesSection from './HolidayThemesSection';
import SupportSection from './SupportSection';
import EnquiryPopup from '../Common/EnquiryPopup';
import Testimonials from '../Testimonials/Testimonials';
import PrimeService from '../PrimeService/PrimeService';
import FAQs from '../FAQs/FAQs';
import AboutUs from '../AboutUs/AboutUs';
import BestTourPackages from './BestTourPackages';
import Services from '../../Services/Services';



const Home = () => {
    return (
        <>
            <div style={{ overflowX: "hidden" }}>
                <BannerSection />
                <BestTourPackages />
                {/* <HolidayThemesSection /> */}
                <TopTrendingSection />
                {/* <InternationalPackages heading="Most Popular Holiday Packages in Andaman" /> */}
                {/* <AddSection /> */}
                {/* <PopularIndianSection sheading="DESTINATION" fheading="Popular" secheading="Indian Destination"  /> */}
                {/* <PopularTourSection heading="Most Popular Indian Tours" /> */}
                {/* <PopularInternationalSection /> */}
                {/* <SupportSection /> */}
                {/* <EnquiryPopup /> */}
                <AboutUs />
                <Services />
                {/* <PrimeService /> */}
                <Testimonials />
                <FAQs />
            </div>
        </>
    )
}

export default Home